"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrRawText = void 0;
const react_1 = __importStar(require("react"));
const fdr_regular_basis_fdr_text_block_1 = require("@hotelplan/fdr.regular.basis.fdr-text-block");
const FdrRawText = ({ uid, title, text, className, }) => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const isPostScribeNeeded = text.includes('</script>');
    (0, react_1.useEffect)(function postScribeEffect() {
        if (!isPostScribeNeeded)
            return;
        const el = document.getElementById(uid);
        // @ts-ignore
        Promise.resolve().then(() => __importStar(require(`postscribe`))).then(({ default: postscribe }) => {
            if (el) {
                el.innerHTML = '';
            }
            postscribe(`#${uid}`, text);
        });
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [uid, text]);
    return (react_1.default.createElement(fdr_regular_basis_fdr_text_block_1.FdrTextBlock, { id: uid, title: title, text: text, className: className }));
};
exports.FdrRawText = FdrRawText;
//# sourceMappingURL=fdr-raw-text.js.map